import { render, staticRenderFns } from "./examinetopic.vue?vue&type=template&id=3cd12647&"
import script from "./examinetopic.vue?vue&type=script&lang=js&"
export * from "./examinetopic.vue?vue&type=script&lang=js&"
import style0 from "./examinetopic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports